

export default {
        async asyncData ({ $axios, params, store }) {
            const data = store.getters.selected;
            return {data};
        },
        props: [],
        components: {

        },
        // scrollToTop: true,   // Currently not working due to a bug. Should have been fixed in latest version of Nuxt
        data : function(){
            return {
                collectionOptions: [],
                selectedCollection: null,
                collectionHidden: false,
                otherCollections: null,
                titleColour: '',
            };
        },
        created: function(){
            },

        computed: {
            account() {
                return this.$store.getters.getAccount;
            },

            collection(){
                const style = this.styleMe('vanilla', 'StoreFront', 'shop-description-text');
                this.titleColour = (style && style[1] && style[1]['color']) ? style[1]['color'] : '#000000';
                let collection = this.$store.getters.getCollectionBySlug(this.$route.params.collection_slug);
                if (collection && !collection.show_on_dropdown && !collection.show_on_tile) {
                    // Hide collection if not flagged to show on dropdown or tile
                    this.collectionHidden = true;
                }

                return collection;
            },

            collections(){
                return this.$store.getters.getCollections;
            },

            products(){
                let products = this.$store.getters.getProducts;
                let collectionProductsIds = this.collection.Products.map(productObj => productObj.id);
                return products.filter(product => {
                    return collectionProductsIds.includes(product.id)
                })
            },

            bundles(){
                let bundles = this.$store.getters.getBundles;
                let collectionBundlesIds = this.collection.Bundles.map(bundleObj => bundleObj.id);
                return bundles.data.filter(bundle => {
                    return collectionBundlesIds.includes(bundle.id)
                })
            }
        },

        watch : {
            collection(){
                this.setCollection();
            },

            selectedCollection : function(value) {
                value === 'all'
                    ? this.$router.push({ name: 'home'})
                    : this.$router.push({ name: 'collection-page', params: {collection_slug: value} });
            }
        },

        created : function(){
            this.setCollection();
        },

        mounted : function ()
        {
            // Set scroll to top functionality
            var body = document.body; // Safari
            var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
            body.scrollTop = 0;
            html.scrollTop = 0;

            if(this.collections) {
                this.getCollectionDropdownOptions();

                // Set selected value of dropdown
                this.selectedCollection = this.collection.slug;

                // Remaining collections are shown in tiles at the bottom of the page
                this.otherCollections = this.collections.filter(collection => collection.id !== this.collection.id && collection.show_on_tile);
            }
        },

        methods:{
            setImage(index){
                this.chosenImageIndex = index;
                let slideIndex = this.product.slideshow ? index + 1 : index;
                this.swiper.slideTo(slideIndex, 500, false);
            },
            setCollection(){
                if(!process.client)
                    return;

                if(this.collection) {
                    this.selectedCollection = this.collection.slug;
                }
                else {
                    this.$router.push({ name: 'notfoundpage'});
                }
            },
            getCollectionDropdownOptions(){
                // Populate dropdown with collections that are flagged to be shown on the dropdown

                let colls = this.collections
                    .filter(collection => collection.show_on_dropdown)
                    .map(collection => {
                        return { value: collection.slug, label: collection.name};
                    }
                );

                // Add default show-all value to dropdown options
                colls.unshift({ value: "all", label: "Show all" });

                // Create copy so as not to modify original
                this.collectionOptions = [...colls];
            }
        },

        head() {
            return {
                title: this.collection.name + ' - ' + this.account.name
            }
        }
    }

